<!--
# Module: 页脚版权信息
-->
<template>
  <div class="login-copyright">
    <!-- <span class="copyright-text">Copyright ©{{year}}&nbsp;广东顺德控股集团有限公司</span> -->
  </div>
</template>

<script>
export default {
  name: 'Copyright',
  computed: {
    // 当年年份
    year () {
      return new Date().getFullYear()
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.login-copyright {
    position: absolute;
    bottom: 25px;
    left: 0;
    width: 100%;
    text-align: center;

    .copyright-text {
        color: #929292;
    }
}
</style>